<template>
  <div class="container mt-5">
    <div class="row mb-5">
      <div class="col-8">
        <h3>Add player(s) <small class="text-muted">{{ $route.params.name }}</small></h3>
      </div>
      <div class="col-4 text-right">
        <button @click="$router.go(-1)" type="button" class="btn btn-secondary">Back</button>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <button class="btn btn-success btn-sm" @click="insertRow">Insert row</button>
        <button class="btn btn-primary btn-sm" v-b-modal.import-opta>Opta F40 Importer (Squads)</button>
      </div>
      <div class="col-4">
        <div class="form-group row">
          <label class="col-2 col-form-label form-control-sm text-right">Sport</label>
          <div class="col-10">
            <select class="form-control form-control-sm" v-if="sports" v-model="sport">
              <option :value="sport._id" v-for="sport of sports" :key="sport._id">{{ sport.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <b-alert variant="danger" class="mt-3 mb-4" dismissible :show="error" @dismissed="error = false">{{errorMessage}}</b-alert>
    <hr>
    <div class="row">
      <div class="col-12">

        <small class="row text-muted mb-2">
          <div class="col-1">Number</div>
          <div class="col-2">First Name</div>
          <div class="col-2">Last Name</div>
          <div class="col-2">Usual Name</div>
          <div class="col-2">Previous y. cards</div>
          <div class="col-2">Position</div>
        </small>
        <!-- Player Row -->
        <div class="row mb-3" v-for="(player, index) of players" :key="player.vue_tracking_id">
          <div class="col-1">
            <input type="number" class="form-control form-control-sm" placeholder="#" name="number" v-model="player.number">
          </div>
          <div class="col-2">
            <input type="text" class="form-control form-control-sm" placeholder="First name" name="first_name" v-model="player.first_name">
          </div>
          <div class="col-2">
            <input type="text" class="form-control form-control-sm" placeholder="Last name" name="last_name" v-model="player.last_name">
          </div>
          <div class="col-2">
            <input type="text" class="form-control form-control-sm" placeholder="Usual name" name="usual_name" v-model="player.usual_name">
          </div>
          <div class="col-2">
            <input type="number" class="form-control form-control-sm" placeholder="Previous y. cards" name="previous_yellow_cards" v-model="player.previous_yellow_cards">
          </div>
          <div class="col-2">
            <select id="" class="form-control form-control-sm" name="position" v-model="player.position" v-if="positions">
              <option v-for="position of positions" :key="position._id" :value="position._id">{{ position.sport.name }} / {{ position.name }}</option>
            </select>
          </div>
          <div class="col-1">
            <button class="btn btn-danger btn-sm btn-block" @click="deleteRow(player)" v-if="index !== 0 || players.length !== 1">Del.</button>
            <button class="btn btn-secondary btn-sm btn-block" @click="deleteRow(player)" v-else disabled>Del.</button>
          </div>
        </div>
        <hr>
        <div class="row">
              <div class="col-12">
                <spreadsheet-insert @data="processSpreadsheetInsert" :fields="[ 'number', 'first_name', 'last_name', 'usual_name', 'previous_yellow_cards', 'position' ]"></spreadsheet-insert>
              </div>
        </div>
        <hr>
        <button class="btn btn-primary btn-lg mt-4" @click="addPlayers">Add player(s)</button>
      </div>
    </div>

    <b-modal id="import-opta" title="Import Opta F40 Feed (Squads)" :no-fade="true" :hide-footer="true">
      <div>
        <h5 class="mb-3">1. Set-up Opta credentials</h5>

        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="competitionId" class="small">Opta Competition Id</label>
              <input type="text" class="form-control form-control-sm" name="competitionId" id="competitionId" v-model="optaForm.competitionId">
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="seasonId" class="small">Opta Season Id</label>
              <input type="text" class="form-control form-control-sm" name="seasonId" id="seasonId" v-model="optaForm.seasonId">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="user" class="small">Opta User</label>
              <input type="text" class="form-control form-control-sm" name="user" id="user" v-model="optaForm.user">
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="password" class="small">Opta Password</label>
              <input type="text" class="form-control form-control-sm" name="password" id="password" v-model="optaForm.password">
            </div>
          </div>
        </div>

        <button class="btn btn-success btn-sm mt-2 fetch" @click="fetchOpta">Fetch</button>
        <div for="fetchStatus" class="small text-muted status mt-3">{{status}}</div>
      </div>

      <div>
        <h5 class="mb-3 mt-4">2. Choose the wanted team</h5>
        <div class="form-group">
          <select name="team" id="team" class="form-control" :disabled="!optaResults" v-model="team">
            <option :value="team.name" v-for="team of optaResults" :key="team.name">{{team.name}} - {{team.players.length}} player(s)</option>
          </select>
        </div>
        <button class="btn btn-success" :disabled="!optaResults" @click="insertOpta">Insert</button>
      </div>
    </b-modal>
    <b-modal ref="submitModal" id="submit-modal" title="Confirmation" :no-fade="true" @ok="submit">
      <div>
        <p>We will add <b>{{ players.length }}</b> new players to "{{ $route.params.name }}":</p>
        <ul>
          <li v-for="player of players" :key="player.vue_tracking_id">
            <b>{{player.number}} {{player.first_name}} {{player.last_name}} {{player.usual_name}}</b>
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { positionService } from '@/services/position'
import { optaService } from '@/services/opta'
import { playerService } from '@/services/player'
import { sportService } from '@/services/sport'
import SpreadsheetInsert from '@/components/SpreadsheetInsert'
export default {
  name: 'PlayerAdd',
  components: { SpreadsheetInsert },
  data () {
    return {
      players: [{ number: null, first_name: '', last_name: '', usual_name: '', previous_yellow_cards: null, position: null, vue_tracking_id: 0 }],
      positionsRaw: null,
      sports: null,
      sport: null,
      errorMessage: null,
      error: false,
      optaForm: {
        competitionId: '',
        seasonId: '',
        user: '',
        password: ' '
      },
      optaResults: null,
      team: null,
      status: 'Waiting for Opta Fetch.'
    }
  },
  computed: {
    positions () {
      if (!this.sport) {
        return this.positionsRaw
      } else {
        return this.positionsRaw.filter(position => position.sport._id === this.sport)
      }
    }
  },
  mounted () {
    positionService.getAll().then(result => {
      this.positionsRaw = result.data.positions
    })
    sportService.getAll().then(result => {
      this.sports = result.data.sports
    })

    const lsOptaImporter = localStorage.getItem('optaImporter')

    if (lsOptaImporter) {
      const optaImporter = JSON.parse(lsOptaImporter)

      this.optaForm = {
        competitionId: optaImporter.competitionId,
        seasonId: optaImporter.seasonId,
        user: optaImporter.user,
        password: optaImporter.password
      }
    }
  },
  methods: {
    insertRow (event) {
      this.players.push({ number: null, first_name: '', last_name: '', usual_name: '', previous_yellow_cards: null, position: null, vue_tracking_id: this.players[this.players.length - 1].vue_tracking_id + 1 })
    },
    deleteRow (player) {
      this.players.splice(this.players.indexOf(player), 1)
    },
    addPlayers (event) {
      this.errorMessage = ''
      this.error = false
      if (!this.sport) {
        this.errorMessage += 'You have to choose a sport on which the player(s) will be added.'
        this.error = true
      } else {
        this.$refs.submitModal.show()
      }
    },

    fetchOpta (event) {
      this.status = 'Fetching...'
      localStorage.setItem('optaImporter', JSON.stringify(this.optaForm))
      optaService.F40(this.optaForm.competitionId, this.optaForm.seasonId, this.optaForm.user, this.optaForm.password).then(result => {
        this.optaResults = result
        this.status = 'Fetched.'
      }).catch(() => {
        this.status = 'Failed to fetched.'
      })
    },

    insertOpta (event) {
      let selectedTeam = this.optaResults.filter(team => team.name === this.team)[0]
      this.players = []
      for (let player of selectedTeam.players) {
        let playerToPush = {
          first_name: player.first_name,
          last_name: player.last_name,
          usual_name: player.usual_name,
          number: player.number
        }
        let availablePositions = this.positions
        playerToPush.position = availablePositions.filter(position => {
          return player.position.toUpperCase() === position.name.toUpperCase()
        })[0]._id
        this.players.push(playerToPush)
      }
    },

    processSpreadsheetInsert (entries) {
      if (entries.length > 0) {
        let availablePositions = this.positions
        this.players = []
        for (let entry of entries) {
          entry.position = availablePositions.filter(position => {
            return entry.position.toUpperCase() === position.name.toUpperCase()
          })[0]._id
          this.players.push(entry)
        }
      }
    },

    submit () {
      let cleanedPlayers = []

      for (let player of this.players) {
        cleanedPlayers.push({
          first_name: player.first_name,
          last_name: player.last_name,
          usual_name: player.usual_name,
          number: player.number,
          previous_yellow_cards: player.previous_yellow_cards,
          team: this.$route.params.team,
          position: player.position,
          sport: this.sport
        })
      }

      playerService.insertMany(cleanedPlayers).then(result => {
        this.$router.go(-1)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.fetch{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/Players/PlayerAdd.vue